// extracted by mini-css-extract-plugin
export default {"container":"ChatRoom_container__oKFUR","barContainer":"ChatRoom_barContainer__DKFSE"};